import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import { ContentContainer } from '../../../../content-container/content-container';
import { RouterLink } from '@angular/router';
import { ReplaceWhitespaceWithHyphenPipe } from '../../../../replace-whitespace-with-hyphen/pipes/replace-whitespace-with-hyphen.pipe';
import { LucideMenu, LucideX } from '@lucide/angular';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { BreakpointObserverDirective } from '@zion/frontend/shared-utils-ui';

@Component({
  selector: 'app-header',
  imports: [
    ContentContainer,
    RouterLink,
    ReplaceWhitespaceWithHyphenPipe,
    LucideMenu,
    LucideX,
    BreakpointObserverDirective,
  ],
  templateUrl: './header.html',
  styleUrl: './header.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header {
  private breakpointObserver = inject(BreakpointObserver);

  protected isMobile = toSignal(
    this.breakpointObserver
      .observe('(max-width: 1280px)')
      .pipe(map((result) => result.matches)),
  );

  protected links = signal([
    {
      url: '/assinaturas/code-universe',
      label: 'Code Universe',
      highlighted: true,
    },
    {
      url: '/cursos',
      label: 'Cursos',
    },
    {
      url: '/mentorias',
      label: 'Mentorias',
    },
    {
      url: 'https://blog.codedimension.com.br',
      label: 'Blog',
    },
    {
      url: 'https://hotmart.com/pt-br/club/code-dimension',
      label: 'Área do Aluno',
    },
  ]);

  resolvedLinks = computed(() => {
    return this.links().map((link) => ({
      ...link,
      isExternal: link.url.startsWith('http'),
      cssClasses: link.highlighted
        ? 'hover:text-white hover:bg-gradient-to-r hover:from-primary hover:to-accent'
        : 'hover:bg-white/10 hover:text-white',
    }));
  });

  protected isMobileMenuModalOpen = signal(false);

  protected openMobileMenuModal() {
    this.isMobileMenuModalOpen.set(true);
  }

  protected closeMobileMenuModal() {
    this.isMobileMenuModalOpen.set(false);
  }
}
